function parsePackSizeOption(option) {
  if (!option) return null;

  const trimmed = option.trim();

  if (/^single(\s+(roll|bottle|pack))?$/i.test(trimmed)) {
    return 1;
  }

  let match = trimmed.match(/^(\d+)\s*rolls?$/i);
  if (match) return parseInt(match[1], 10);

  match = trimmed.match(/^(\d+)\s*pack$/i);
  if (match) return parseInt(match[1], 10);

  match = trimmed.match(/^(box|pack)\s+of\s+(\d+)$/i);
  if (match) return parseInt(match[2], 10);

  match = trimmed.match(/^roll\s+of\s+(\d+)$/i);
  if (match) return parseInt(match[1], 10);

  return null;
}

function getVariantGroupKey(option1, option2, option3) {
  return [option1, option2, option3]
    .filter(Boolean)
    .filter((option) => parsePackSizeOption(option) === null)
    .join('|');
}

function getVariantInfo(option1, option2, option3) {
  let packSize = 1;
  let packSizeOption = null;

  [option1, option2, option3].forEach((option) => {
    const parsed = parsePackSizeOption(option);
    if (parsed !== null) {
      packSize = parsed;
      packSizeOption = option;
    }
  });

  return { packSize, packSizeOption };
}

function findPackSizeOptionLabel(variant) {
  return [variant.option1, variant.option2, variant.option3]
    .filter(Boolean)
    .find((option) => parsePackSizeOption(option) !== null);
}

function getProductJson() {
  const productJsonElement = document.querySelector('[data-product-json]');
  if (!productJsonElement) return null;

  try {
    return JSON.parse(productJsonElement.textContent);
  } catch (error) {
    console.error('[multibuy] Failed to parse product JSON', error);
    return null;
  }
}

function getInitialVariant() {
  const productJSON = getProductJson();
  const variantIdElement = document.querySelector('.variant_default_id');

  if (!productJSON || !variantIdElement) return null;

  const variantId = parseInt(variantIdElement.value, 10);
  return productJSON.variants.find((variant) => variant.id === variantId) || null;
}

function getSelectedVariantData() {
  const productJSON = getProductJson();
  if (!productJSON) return null;

  const selectedOptions = Array.from(
    document.querySelectorAll('.variant-picker__option input:checked')
  ).map((input) => input.value);

  return productJSON.variants.find((variant) =>
    variant.options.every((option, index) => option === selectedOptions[index])
  );
}

function getSameGroupVariants(allVariants, variant) {
  const groupKey = getVariantGroupKey(variant.option1, variant.option2, variant.option3);

  return allVariants
    .filter((candidate) => {
      if (!candidate.available || candidate.requires_selling_plan) return false;
      if (parsePackSizeOption(findPackSizeOptionLabel(candidate)) === null) return false;

      return (
        getVariantGroupKey(candidate.option1, candidate.option2, candidate.option3) === groupKey
      );
    })
    .sort((a, b) => {
      const aInfo = getVariantInfo(a.option1, a.option2, a.option3);
      const bInfo = getVariantInfo(b.option1, b.option2, b.option3);
      return aInfo.packSize - bInfo.packSize;
    });
}

function updateMultibuyNotificationNonB2B(variant) {
  const productJSON = getProductJson();
  const notificationElement = document.querySelector('[data-multibuy-notification]');

  if (!productJSON || !notificationElement || !variant) return;

  const sameGroupVariants = getSameGroupVariants(productJSON.variants, variant);

  if (sameGroupVariants.length < 2) {
    notificationElement.style.display = 'none';
    return;
  }

  const currentInfo = getVariantInfo(variant.option1, variant.option2, variant.option3);
  const nextSizeUpVariant = sameGroupVariants.find((candidate) => {
    const candidateInfo = getVariantInfo(candidate.option1, candidate.option2, candidate.option3);
    return candidateInfo.packSize > currentInfo.packSize;
  });

  if (!nextSizeUpVariant) {
    notificationElement.style.display = 'none';
    return;
  }

  const smallestVariant = sameGroupVariants[0];
  const smallestInfo = getVariantInfo(
    smallestVariant.option1,
    smallestVariant.option2,
    smallestVariant.option3
  );
  const nextInfo = getVariantInfo(
    nextSizeUpVariant.option1,
    nextSizeUpVariant.option2,
    nextSizeUpVariant.option3
  );

  const smallestPricePerUnit = smallestVariant.price / smallestInfo.packSize;
  const nextSizeUpPricePerUnit = nextSizeUpVariant.price / nextInfo.packSize;
  const savingsPercentage = Math.round(
    (1 - nextSizeUpPricePerUnit / smallestPricePerUnit) * 100
  );

  if (savingsPercentage <= 0) {
    notificationElement.style.display = 'none';
    return;
  }

  notificationElement.querySelector('[data-savings-percentage]').textContent = savingsPercentage;
  notificationElement.querySelector('[data-pack-unit]').textContent =
    findPackSizeOptionLabel(nextSizeUpVariant) || '';
  notificationElement.style.display = 'block';
}

function updateMultibuyNotificationB2B(variant) {
  const productJSON = getProductJson();
  const notificationElement = document.querySelector('[data-multibuy-notification]');

  if (!productJSON || !notificationElement || !variant) return;

  const showExVat =
    document.documentElement.getAttribute('data-vat-mode') === 'ex';
  const sameGroupVariants = getSameGroupVariants(productJSON.variants, variant);

  if (sameGroupVariants.length < 2) {
    notificationElement.style.display = 'none';
    return;
  }

  const currentInfo = getVariantInfo(variant.option1, variant.option2, variant.option3);
  const nextSizeUpVariant = sameGroupVariants.find((candidate) => {
    const candidateInfo = getVariantInfo(candidate.option1, candidate.option2, candidate.option3);
    return candidateInfo.packSize > currentInfo.packSize;
  });

  if (!nextSizeUpVariant) {
    notificationElement.style.display = 'none';
    return;
  }

  const smallestVariant = sameGroupVariants[0];
  const smallestInfo = getVariantInfo(
    smallestVariant.option1,
    smallestVariant.option2,
    smallestVariant.option3
  );
  const nextInfo = getVariantInfo(
    nextSizeUpVariant.option1,
    nextSizeUpVariant.option2,
    nextSizeUpVariant.option3
  );

  const smallestPricePerUnit =
    (showExVat
      ? (window.sporttapeExVatCents
          ? window.sporttapeExVatCents(smallestVariant.price)
          : Math.round(smallestVariant.price / 1.2))
      : smallestVariant.price) / smallestInfo.packSize;
  const nextSizeUpPricePerUnit =
    (showExVat
      ? (window.sporttapeExVatCents
          ? window.sporttapeExVatCents(nextSizeUpVariant.price)
          : Math.round(nextSizeUpVariant.price / 1.2))
      : nextSizeUpVariant.price) /
    nextInfo.packSize;
  const savingsPercentage = Math.round(
    ((smallestPricePerUnit - nextSizeUpPricePerUnit) / smallestPricePerUnit) * 100
  );

  if (savingsPercentage <= 0) {
    notificationElement.style.display = 'none';
    return;
  }

  notificationElement.querySelector('[data-savings-percentage]').textContent = savingsPercentage;
  notificationElement.querySelector('[data-pack-unit]').textContent =
    findPackSizeOptionLabel(nextSizeUpVariant) || '';
  notificationElement.style.display = 'block';
}

function updateMultibuyNotification(variant) {
  if (!variant) return;

  const b2bUserElement = document.querySelector('.b2bUser');

  if (b2bUserElement && b2bUserElement.getAttribute('value') === 'true') {
    updateMultibuyNotificationB2B(variant);
  } else {
    updateMultibuyNotificationNonB2B(variant);
  }
}

function selectNextPackSize(event) {
  if (event) event.preventDefault();

  const packUnitSpan = document.querySelector('[data-pack-unit]');
  if (!packUnitSpan) return;

  const targetPackSize = packUnitSpan.textContent.trim();
  const packSizeInput = document.querySelector(
    `input[type="radio"][value="${CSS.escape(targetPackSize)}"]`
  );

  if (!packSizeInput) return;

  packSizeInput.checked = true;
  packSizeInput.dispatchEvent(new Event('change', { bubbles: true }));

  window.setTimeout(() => {
    const newVariant = getSelectedVariantData();
    if (!newVariant) return;

    updateMultibuyNotification(newVariant);
    document.dispatchEvent(
      new CustomEvent('variant:change', {
        detail: { variant: newVariant },
      })
    );
  }, 0);
}

function initializePackSizeSelector() {
  const packSizeSelector = document.querySelector('[data-pack-size-selector]');

  if (!packSizeSelector || packSizeSelector.hasAttribute('data-initialized')) return;

  packSizeSelector.addEventListener('click', selectNextPackSize);
  packSizeSelector.setAttribute('data-initialized', 'true');
}

function initializeMultibuy() {
  if (!document.querySelector('[data-multibuy-notification]')) return;

  initializePackSizeSelector();

  const initialVariant = getInitialVariant();
  if (initialVariant) {
    updateMultibuyNotification(initialVariant);
  }
}

document.addEventListener('DOMContentLoaded', initializeMultibuy);
document.addEventListener('shopify:section:load', initializeMultibuy);
document.addEventListener('variant:change', (event) => {
  if (event.detail?.skipMultibuyUpdate) return;
  updateMultibuyNotification(event.detail?.variant);
});
